import React, { useMemo } from 'react';
import { useIntl, getLocale } from 'umi';
import SortBy, { SortByListItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';

import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import {
  DataSourceBubbleInfo,
  DATASOURCE_NAME,
} from '@/pages/intelligence/components/DataSourceComponents';
import { ITableInfoListProp } from '@/pages/intelligence/pages/GenreProfile/typings';
import { METRICS_TEXT_MAP } from '../config';

export default function MetricColHeader(props) {
  const { config, sortKey, sortOrder, entityType, infoConfig, onSortChange } =
    props;
  const {
    title: propsTitle,
    source: metricSource,
    metric: metricName,
    isNeedSort = false,
    // 排序下拉中是否有环比排序功能
    noRatio=false,
    align,
    childWidth,
    childAlign,
    metricExplanation,
    isNoTips,
  } = config;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  // 转换翻译
  const title: string = useMemo(() => formatMessage({ id: propsTitle }), [propsTitle, locale]);

  const getSortList = (): SortByListItemType[] => {
    if (!isNeedSort) return [];
    const tmpList = [
      {
        key: `${metricName}_0`,
        text: title,
        title,
        ratioType: 0,
      }      
    ];
    if (!noRatio) {
      tmpList.push({
        key: `${metricName}_1`,
        text: `${title}:${formatMessage({ id: 'dbi_change' })}(%)`,
        title: `${title}(%)`,
        ratioType: 1,
      });
    }
    return tmpList;
  };

  const tagetMetricExplanation = useMemo(() => {
    const metricTextList =
      metricExplanation || METRICS_TEXT_MAP[`${metricName}`];
    let str = '';
    metricTextList?.forEach((textKey: string) => {
      str += formatMessage({ id: textKey });
    });
    return str;
  }, [metricSource, metricName, metricExplanation, locale]);

  const getTipText = (_metricName: string) => {
    const find = infoConfig?.find(
      (item: ITableInfoListProp) => item.key === _metricName,
    );
    if (!find) return null;
    return <span>{formatMessage({ id: find.text })}</span>;
  };

  const getElContent = () => (
    <SortBy
      key={metricName}
      defaultKey={sortKey}
      defaultValue={sortOrder}
      svgIcon={getDataSourceIcon(metricSource)}
      svgTip={
        !isNoTips && <DataSourceBubbleInfo
          dataOfDom={title}
          comesFormDom={
            <>
              <img src={getDataSourceIcon(metricSource)} />
              {DATASOURCE_NAME[metricSource]}
            </>
          }
          dataSource={metricSource}
          metricKey={metricName}
          entityType={entityType}
        />
      }
      // 指标的提示由metricExplanation决定，这个是特殊的
      // 如果metricExplanation没有，则使用source_metric查询
      content={!isNoTips && <>{tagetMetricExplanation}</>}
      list={getSortList()}
      title={title}
      isNoDropdown={!isNeedSort}
      tipText={getTipText(metricName)}
      onChange={onSortChange}
    />
  );

  return (
    <>
      {align === 'center' ? (
        <CloumsCenter
          width={childWidth}
          // style={{ marginLeft: '-40px' }}
          align={childAlign}
        >
          {getElContent()}
        </CloumsCenter>
      ) : (
        getElContent()
      )}
    </>
  );
}
